import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const svg = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    viewBox='5.684341886080802e-14 0 24 23.999999999999996'
    width='24'
    height='24'
  >
    <defs>
      <path
        d='M0 24L0 13.09L10.91 13.09L10.91 24L0 24ZM2.18 21.8L8.73 21.8L8.73 15.27L2.18 15.27L2.18 21.8Z'
        id='bvkLnYu84'
      />
      <path
        d='M0 24L0 13.09L10.91 13.09L10.91 24L0 24ZM2.18 21.8L8.73 21.8L8.73 15.27L2.18 15.27L2.18 21.8Z'
        id='b1GTnsa9u6'
      />
      <path
        d='M6.55 17.45C6.55 18.76 6.55 19.49 6.55 19.64C6.55 19.64 6.55 19.64 6.55 19.64C5.24 19.64 4.51 19.64 4.36 19.64C4.36 19.64 4.36 19.64 4.36 19.64C4.36 18.33 4.36 17.6 4.36 17.45C4.36 17.45 4.36 17.45 4.36 17.45C5.67 17.45 6.4 17.45 6.55 17.45C6.55 17.45 6.55 17.45 6.55 17.45Z'
        id='bFP2hhwGz'
      />
      <path
        d='M6.55 17.45C6.55 18.76 6.55 19.49 6.55 19.64C6.55 19.64 6.55 19.64 6.55 19.64C5.24 19.64 4.51 19.64 4.36 19.64C4.36 19.64 4.36 19.64 4.36 19.64C4.36 18.33 4.36 17.6 4.36 17.45C4.36 17.45 4.36 17.45 4.36 17.45C5.67 17.45 6.4 17.45 6.55 17.45C6.55 17.45 6.55 17.45 6.55 17.45Z'
        id='a5QGQycQ94'
      />
      <path
        d='M19.64 21.82C19.64 23.13 19.64 23.85 19.64 24C19.64 24 19.64 24 19.64 24C18.33 24 17.6 24 17.45 24C17.45 24 17.45 24 17.45 24C17.45 22.69 17.45 21.96 17.45 21.82C17.45 21.82 17.45 21.82 17.45 21.82C18.76 21.82 19.49 21.82 19.64 21.82C19.64 21.82 19.64 21.82 19.64 21.82Z'
        id='e13TC849rI'
      />
      <path
        d='M19.64 21.82C19.64 23.13 19.64 23.85 19.64 24C19.64 24 19.64 24 19.64 24C18.33 24 17.6 24 17.45 24C17.45 24 17.45 24 17.45 24C17.45 22.69 17.45 21.96 17.45 21.82C17.45 21.82 17.45 21.82 17.45 21.82C18.76 21.82 19.49 21.82 19.64 21.82C19.64 21.82 19.64 21.82 19.64 21.82Z'
        id='aDtLV4rOl'
      />
      <path
        d='M24 21.82C24 23.13 24 23.85 24 24C24 24 24 24 24 24C22.69 24 21.96 24 21.82 24C21.82 24 21.82 24 21.82 24C21.82 22.69 21.82 21.96 21.82 21.82C21.82 21.82 21.82 21.82 21.82 21.82C23.13 21.82 23.85 21.82 24 21.82C24 21.82 24 21.82 24 21.82Z'
        id='a4I6qgKkb9'
      />
      <path
        d='M24 21.82C24 23.13 24 23.85 24 24C24 24 24 24 24 24C22.69 24 21.96 24 21.82 24C21.82 24 21.82 24 21.82 24C21.82 22.69 21.82 21.96 21.82 21.82C21.82 21.82 21.82 21.82 21.82 21.82C23.13 21.82 23.85 21.82 24 21.82C24 21.82 24 21.82 24 21.82Z'
        id='d4R20MZDC'
      />
      <path
        d='M19.64 13.09L13.09 13.09L13.09 24L15.27 24L15.27 17.45L17.45 17.45L17.45 19.64L24 19.64L24 13.09L24 13.09L21.82 13.09L21.82 15.27L19.64 15.27L19.64 13.09Z'
        id='atjTpVEhP'
      />
      <path
        d='M19.64 13.09L13.09 13.09L13.09 24L15.27 24L15.27 17.45L17.45 17.45L17.45 19.64L24 19.64L24 13.09L24 13.09L21.82 13.09L21.82 15.27L19.64 15.27L19.64 13.09Z'
        id='caFb0VQKc'
      />
      <path
        d='M0 10.91L0 0L10.91 0L10.91 10.91L0 10.91ZM2.18 8.73L8.73 8.73L8.73 2.18L2.18 2.18L2.18 8.73Z'
        id='a1FjI45ay'
      />
      <path
        d='M0 10.91L0 0L10.91 0L10.91 10.91L0 10.91ZM2.18 8.73L8.73 8.73L8.73 2.18L2.18 2.18L2.18 8.73Z'
        id='h5WRUvl41'
      />
      <path
        d='M6.55 4.36C6.55 5.67 6.55 6.4 6.55 6.55C6.55 6.55 6.55 6.55 6.55 6.55C5.24 6.55 4.51 6.55 4.36 6.55C4.36 6.55 4.36 6.55 4.36 6.55C4.36 5.24 4.36 4.51 4.36 4.36C4.36 4.36 4.36 4.36 4.36 4.36C5.67 4.36 6.4 4.36 6.55 4.36C6.55 4.36 6.55 4.36 6.55 4.36Z'
        id='eu7wE8VgC'
      />
      <path
        d='M6.55 4.36C6.55 5.67 6.55 6.4 6.55 6.55C6.55 6.55 6.55 6.55 6.55 6.55C5.24 6.55 4.51 6.55 4.36 6.55C4.36 6.55 4.36 6.55 4.36 6.55C4.36 5.24 4.36 4.51 4.36 4.36C4.36 4.36 4.36 4.36 4.36 4.36C5.67 4.36 6.4 4.36 6.55 4.36C6.55 4.36 6.55 4.36 6.55 4.36Z'
        id='bEPjCF7lH'
      />
      <path
        d='M13.09 10.91L13.09 0L24 0L24 10.91L13.09 10.91ZM15.27 8.73L21.82 8.73L21.82 2.18L15.27 2.18L15.27 8.73Z'
        id='a17MRtVtx5'
      />
      <path
        d='M13.09 10.91L13.09 0L24 0L24 10.91L13.09 10.91ZM15.27 8.73L21.82 8.73L21.82 2.18L15.27 2.18L15.27 8.73Z'
        id='c7OjITkHsD'
      />
      <path
        d='M19.64 4.36C19.64 5.67 19.64 6.4 19.64 6.55C19.64 6.55 19.64 6.55 19.64 6.55C18.33 6.55 17.6 6.55 17.45 6.55C17.45 6.55 17.45 6.55 17.45 6.55C17.45 5.24 17.45 4.51 17.45 4.36C17.45 4.36 17.45 4.36 17.45 4.36C18.76 4.36 19.49 4.36 19.64 4.36C19.64 4.36 19.64 4.36 19.64 4.36Z'
        id='a4snXN0ad'
      />
      <path
        d='M19.64 4.36C19.64 5.67 19.64 6.4 19.64 6.55C19.64 6.55 19.64 6.55 19.64 6.55C18.33 6.55 17.6 6.55 17.45 6.55C17.45 6.55 17.45 6.55 17.45 6.55C17.45 5.24 17.45 4.51 17.45 4.36C17.45 4.36 17.45 4.36 17.45 4.36C18.76 4.36 19.49 4.36 19.64 4.36C19.64 4.36 19.64 4.36 19.64 4.36Z'
        id='aaSHpAdFW'
      />
    </defs>
    <use xlinkHref='#bvkLnYu84' fill='#fff' />
    <use
      xlinkHref='#bvkLnYu84'
      fillOpacity='0'
      stroke='#000'
      strokeOpacity='0'
    />
    <use xlinkHref='#b1GTnsa9u6' fillOpacity='0' />
    <use
      xlinkHref='#b1GTnsa9u6'
      fillOpacity='0'
      stroke='#000'
      strokeOpacity='0'
    />
    <use xlinkHref='#bFP2hhwGz' fill='#fff' />
    <use
      xlinkHref='#bFP2hhwGz'
      fillOpacity='0'
      stroke='#000'
      strokeOpacity='0'
    />
    <use xlinkHref='#a5QGQycQ94' fillOpacity='0' />
    <use
      xlinkHref='#a5QGQycQ94'
      fillOpacity='0'
      stroke='#000'
      strokeOpacity='0'
    />
    <use xlinkHref='#e13TC849rI' fill='#fff' />
    <use
      xlinkHref='#e13TC849rI'
      fillOpacity='0'
      stroke='#000'
      strokeOpacity='0'
    />
    <use xlinkHref='#aDtLV4rOl' fillOpacity='0' />
    <use
      xlinkHref='#aDtLV4rOl'
      fillOpacity='0'
      stroke='#000'
      strokeOpacity='0'
    />
    <use xlinkHref='#a4I6qgKkb9' fill='#fff' />
    <use
      xlinkHref='#a4I6qgKkb9'
      fillOpacity='0'
      stroke='#000'
      strokeOpacity='0'
    />
    <use xlinkHref='#d4R20MZDC' fillOpacity='0' />
    <use
      xlinkHref='#d4R20MZDC'
      fillOpacity='0'
      stroke='#000'
      strokeOpacity='0'
    />
    <use xlinkHref='#atjTpVEhP' fill='#fff' />
    <use
      xlinkHref='#atjTpVEhP'
      fillOpacity='0'
      stroke='#000'
      strokeOpacity='0'
    />
    <g>
      <use xlinkHref='#caFb0VQKc' fillOpacity='0' />
      <use
        xlinkHref='#caFb0VQKc'
        fillOpacity='0'
        stroke='#000'
        strokeOpacity='0'
      />
    </g>
    <g>
      <use xlinkHref='#a1FjI45ay' fill='#fff' />
      <use
        xlinkHref='#a1FjI45ay'
        fillOpacity='0'
        stroke='#000'
        strokeOpacity='0'
      />
    </g>
    <g>
      <use xlinkHref='#h5WRUvl41' fillOpacity='0' />
      <use
        xlinkHref='#h5WRUvl41'
        fillOpacity='0'
        stroke='#000'
        strokeOpacity='0'
      />
    </g>
    <g>
      <use xlinkHref='#eu7wE8VgC' fill='#fff' />
      <use
        xlinkHref='#eu7wE8VgC'
        fillOpacity='0'
        stroke='#000'
        strokeOpacity='0'
      />
    </g>
    <g>
      <use xlinkHref='#bEPjCF7lH' fillOpacity='0' />
      <use
        xlinkHref='#bEPjCF7lH'
        fillOpacity='0'
        stroke='#000'
        strokeOpacity='0'
      />
    </g>
    <g>
      <use xlinkHref='#a17MRtVtx5' fill='#fff' />
      <use
        xlinkHref='#a17MRtVtx5'
        fillOpacity='0'
        stroke='#000'
        strokeOpacity='0'
      />
    </g>
    <g>
      <use xlinkHref='#c7OjITkHsD' fillOpacity='0' />
      <use
        xlinkHref='#c7OjITkHsD'
        fillOpacity='0'
        stroke='#000'
        strokeOpacity='0'
      />
    </g>
    <g>
      <use xlinkHref='#a4snXN0ad' fill='#fff' />
      <use
        xlinkHref='#a4snXN0ad'
        fillOpacity='0'
        stroke='#000'
        strokeOpacity='0'
      />
    </g>
    <g>
      <use xlinkHref='#aaSHpAdFW' fillOpacity='0' />
      <use
        xlinkHref='#aaSHpAdFW'
        fillOpacity='0'
        stroke='#000'
        strokeOpacity='0'
      />
    </g>
  </svg>
);

const QRIcon = (props: any) => {
  return <SvgIcon {...props}>{svg}</SvgIcon>;
};

export default QRIcon;
